// Getting the theme color based on data-attr.
export const colorFinder = (e) => {
    switch(e.dataset.theme) {
        case 'red':
            return 'red';

        case 'red-inverted':
            return 'red-inverted';

        case 'eggplant':
            return 'eggplant';

        case 'eggplant-inverted':
            return 'eggplant-inverted';

        case 'coolDijon':
            return 'coolDijon';

        case 'coolDijon-inverted':
            return 'coolDijon-inverted';

        case 'parsnip':
            return 'parsnip';

        case 'parsnip-inverted':
            return 'parsnip-inverted';
    }
}

// Adding the theme color.
export const colorChange = () => {
    const themeColor = document.querySelector('.theme-color');
    let clr = colorFinder(document.querySelector('.theme-main'));
    themeColor.className = '';
    themeColor.classList.add(`theme-color`);
    themeColor.classList.add(`theme-color--${clr}`);
}

// Identifying the next page's theme and changing the overlay's color.
export const overlayColor = () => {
        // Selecting the next page's theme-main.
        let main = document.querySelector('.theme-main:nth-child(2)');
        let overlay = document.querySelector('.overlay');

        // Changing background color of overlay same to the next page's backgruond.
        let clr = colorFinder(main);
        overlay.className = '';
        overlay.classList.add(`overlay`);
        overlay.classList.add(`theme-color`);
        overlay.classList.add(`theme-color--${clr}`);
}